import { render, staticRenderFns } from "./SingleProject.vue?vue&type=template&id=5f4a4ae0&"
import script from "./SingleProject.vue?vue&type=script&lang=js&"
export * from "./SingleProject.vue?vue&type=script&lang=js&"
import style0 from "./SingleProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports